import createStyles from "@mui/styles/createStyles";
import makeStyles from "@mui/styles/makeStyles";
import { OLTheme } from "contexts/Theme/ThemeProvider";

export const useStyles = makeStyles((theme: OLTheme) =>
  createStyles({
    tabs: {
      margin: theme.spacing(6, 12),
    },
    boxWrapper: {
      borderRadius: "8px",
      boxShadow: "0px 1px 1px 0px rgba(154, 147, 147, 0.25)",
      border: `1px solid ${theme.gray200}`,
      overflow: "hidden",
      fontSize: "14px",
      margin: theme.spacing(12),
      background: theme.white00,
    },
    capitalized: {
      textTransform: "capitalize",
    },
    separator: {
      width: "100%",
      height: "1px",
      backgroundColor: theme.gray100,
    },
    header: {
      padding: theme.spacing(6, 8),
      backgroundColor: theme.gray50,
      fontWeight: 500,
      color: theme.gray800,
      boxShadow: `0px 1px 0px 0px ${theme.gray100}`,
    },
    subHeader: {
      padding: theme.spacing(6, 8),
      backgroundColor: theme.gray50,
      borderTop: `1px solid ${theme.gray100}`,
      borderBottom: `1px solid ${theme.gray100}`,
    },
    item: {
      padding: theme.spacing(8, 12),
      display: "flex",
      justifyContent: "space-between",
      boxShadow: `0px 1px 0px 0px ${theme.gray100}`,
    },
    itemName: { color: theme.gray500 },
    itemValue: {
      color: theme.gray800,
      gap: 10,
      fontWeight: 500,
      maxWidth: "50%",
      flexWrap: "wrap",
      overflow: "hidden",
      whiteSpace: "nowrap",
      textOverflow: "ellipsis",
    },
    title: {
      fontSize: "16px",
      fontWeight: 500,
      marginBottom: theme.spacing(8),
    },
    conditionsHeader: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
    },
    tier: {
      marginBottom: theme.spacing(8),
    },
    tierName: {
      fontWeight: 500,
      color: theme.gray800,
      marginBottom: theme.spacing(8),
    },
    condition: { display: "flex", flexDirection: "column" },
    conditionAttribute: {
      color: theme.gray500,
      fontSize: "14px",
      textWrap: "nowrap",
    },
    conditionValue: {
      color: theme.primary800,
      fontSize: "16px",
    },
    conditionList: {
      marginBottom: theme.spacing(12),
    },
    tierList: {
      paddingBottom: theme.spacing(6),
    },
    expandIcon: {
      color: theme.primary500,
    },
    expandedView: {
      position: "fixed",
      top: 0,
      left: 0,
      width: "100vw",
      height: "100vh",
      zIndex: 9999,
      borderRadius: 0,
      padding: theme.spacing(12, 30),
      overflow: "auto",
    },
    closeIconWrapper: {
      backgroundColor: "#F0F0F0",
      width: "28px",
      height: "28px",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      borderRadius: "50%",
      cursor: "pointer",

      "& svg": {
        color: "#9B9B9B",
      },
    },
    exportBtn: {
      margin: theme.spacing(12, 12, 0),
      padding: 0,
    },
    inactiveTier: {
      opacity: 0.5,
    },
    tierWrapper: {
      flexWrap: "nowrap",
      paddingBottom: theme.spacing(8),
    },
    tiers: {
      overflowX: "auto",
    },
  }),
);
